export default __webpack_public_path__ + "static/media/logo512.d0b143ab.png";